import { ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import Pagination from '@10xLabs/react-web/components/Pagination'
import { PaginationCaption } from 'features/App/components/PaginationCaption'

const PaginationContainer = styled(Pagination.Container)<{ withPaddingVertical?: boolean }>`
  padding: ${({ withPaddingVertical }): string => (withPaddingVertical ? '16px 0' : '0')};
`
export interface IPaginationListProps {
  page: number
  totalItems: number
  limit: number
  currentItemsCount: number
  withPaddingVertical?: boolean
}

export const PaginationList = ({
  page,
  totalItems,
  limit,
  currentItemsCount,
  withPaddingVertical
}: IPaginationListProps): ReactElement => {
  const [, setSearchParams] = useSearchParams()

  const setPage = (page: number): void => {
    setSearchParams((prev) => {
      prev.set('page', page.toString())
      return prev
    })
  }

  return (
    <PaginationContainer withPaddingVertical={withPaddingVertical}>
      <Pagination.Caption
        page={page}
        totalItems={totalItems}
        currentItemsCount={currentItemsCount}
        limit={limit}
        getCaptionMessage={(firstItemIndex: number, lastItemIndex: number): ReactElement => (
          <PaginationCaption firstItemIndex={firstItemIndex} lastItemIndex={lastItemIndex} totalItems={totalItems} />
        )}
      />
      <Pagination.Previous page={page} setPage={setPage} />
      <Pagination.Next page={page} totalItems={totalItems} limit={limit} setPage={setPage} />
    </PaginationContainer>
  )
}
